//let url = "http://localhost:3000";
let url = "https://dev-apis.ilaqa.com";
if (process.env.REACT_APP_API_URL) url = process.env.REACT_APP_API_URL;
export const URL = url;
